import { render } from "./ModalQR.vue?vue&type=template&id=1c0050b8&scoped=true"
import script from "./ModalQR.vue?vue&type=script&lang=js"
export * from "./ModalQR.vue?vue&type=script&lang=js"

import "./ModalQR.vue?vue&type=style&index=0&id=1c0050b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0050b8"]])

export default __exports__